import React from 'react'

import ISafe from '@interco/icons/core/privacy-security/ic_i_safe'
import PrepaymentOfReceivables from '@interco/icons/core/action-navigation/ic_calendar_money'
import { Colors } from '@utils/Colors'

export enum FontesPagamento {
  DEFAULT = 0,
  ESTADUAL = 1,
  MUNICIPAL = 2,
  INSS = 3,
  FEDERAL_SIAPE = 4,
  FORCAS_ARMADAS = 7,
}

export enum ErrorCodes {
  // Refinanciamento
  RE_001_CONTRATOS = 'RE.001', // src/store/refinanciamento/simulacao/sagas/getContratos.ts
  RE_002_SIMULACAO = 'RE.002', // src/store/refinanciamento/simulacao/sagas/postSimulacao.ts
  RE_003_SALVAR_LEAD = 'RE.003', // src/store/refinanciamento/simulacao/sagas/postSalvarLead.ts

  RE_004_ENVIAR_ASSINATURA = 'RE.004', // src/store/refinanciamento/documentosAssinatura/sagas/sendDocumentosAssinatura.ts
  RE_005_ENVIAR_ASSINCRONO = 'RE.005', // src/store/refinanciamento/documentosAssinatura/sagas/postDocumentoAssincronoSaga.ts
  RE_006_BUSCAR_IDSIMULACAO = 'RE.006', // src/store/refinanciamento/simulacao/sagas/getSimulacaoId.ts
  RE_007_CRIAR_PROPOSTA = 'RE.007', // src/store/refinanciamento/proposta/sagas/postCriarProposta.ts
  RE_008_SALVAR_PROPOSTA = 'RE.008', // src/store/refinanciamento/proposta/sagas/postSalvarPropostaSaga.ts
}

export enum ConveniosCodes {
  ESTADO_MG = 1,
  TJMG = 2,
  SIAPE_SERVIDOR_FEDERAL = 3,
  ESTADO_RJ = 4,
  PREF_BH = 5,
  INSS = 6,
  ESTADO_SP = 10,
  ESTADO_BAHIA = 12,
  MARINHA_BR = 13,
  ESTADO_MS = 14,
  PREF_SALVADOR = 16,
  PREF_SP = 17,
  ESTADO_GO = 20,
  FORCA_AEREA_BR = 23,
  PREF_CONTAGEM = 34,
  EXERCITO_BR = 37,
  HOSPITAL_ODILON = 42,
  MIN_PUB_MG = 43,
  TRE_MG = 45,
  METRO = 46,
  CTPS = 47,
  TRE_SP = 55,
  STJ = 56,
  TCE_MG = 62,
  TRT = 75,
  ESTADO_MT = 105,
}

export enum TipoEmprestimo {
  CREDITO_PROTEGIDO = 'simulationsWithInsurance',
  SEM_CREDITO_PROTEGIDO = 'simulations',
}

export enum StepRefin {
  CONTATOS = 'contatos',
  CONTRATAR_CONTATOS = 'contratar-contatos',
  VALIDADO_SMS_CONTATOS = 'validado-sms-contatos',
  VALIDADO_EMAIL_CONTATOS = 'validado-email-contatos',
  CONTRATOS = 'contratos',
  DOCUMENTACAO_AUTORIZADA = 'documentacao-autorizada',
  LEITURA_DOCUMENTACAO_AUTORIZACAO = 'leitura-documentacao-autorizacao',
  OFERTA_SEGURO = 'oferta-seguro',
  SIMULAR_CONTRATOS = 'simular-contratos',
  CONTRATOS_NAO_ELEGIVEIS = 'contratos-nao-elegiveis',
  PARCELAMENTO = 'parcelamento',
  SELECIONADO_PARCELAMENTO = 'selecionado-parcelamento',
  RESULTADO = 'resultado',
  RESULTADO_SIMULACAO = 'resultado-simulacao',
  INICIO_CAPTURA = 'inicio-captura-dados',
  ENDERECO = 'envio-dados-endereco',
  DADOS_BANCARIOS = 'envio-dados-bancarios',
  CONTRATAR_SIMULACAO_REFIN = 'contratar-simulacao-refin',
  SOLICITAR_CONTRATACAO = 'solicitar-contratacao',
  DADOS_RECEBIDO = 'dados-recebido',
  NAO_LIBERADO = 'nao-liberado',
  ORIENTACOES_VIDEO_SELFIE = 'orientacoes-gravar-video-selfie',
  GRAVAR_VIDEO_SELFIE = 'gravar-video-selfie',
  CONCLUSAO_ENVIO_DOCUMENTOS = 'conclusao-envio-biometria',
  REVISAO_ASSINATURA = 'revisao-assinatura',
  PROPOSTA_FINALIZADA = 'proposta-finalizada',
  INICIO_CAPTURA_DOCUMENTOS = 'inicio-captura-documentos',
  STATUS_DOCUMENTOS = 'status-documentos',
  FOTOGRAFAR_DOCUMENTO = 'fotografar-documento',
  ANEXAR_DOCUMENTO = 'anexar-documento',
  ANEXO_DE_DOCUMENTOS_CONCLUIDO = 'anexo-documentos-concluido',
  ERRO = 'erro',
  ERRO_CARREGAMENTO_INSS_DADOS_1 = 'erro-carregamento-inss-dados-1',
  ERRO_CARREGAMENTO_INSS_DADOS_2 = 'erro-carregamento-inss-dados-2',
  ERRO_CARREGAMENTO_SIAPE_DADOS_1 = 'erro-carregamento-siape-dados-1',
  ERRO_CARREGAMENTO_SIAPE_DADOS_2 = 'erro-carregamento-siape-dados-2',
  ERRO_CARREGAMENTO_CTPS_DADOS_1 = 'erro-carregamento-ctps-dados-1',
  ERRO_CARREGAMENTO_CTPS_DADOS_2 = 'erro-carregamento-ctps-dados-2',
  ERRO_CARREGAMENTO_SIAPE_SIMULAR = 'erro-carregamento-siape-simular',
  ERRO_CONVENIO_INDISPONIVEL = 'erro-convenio-indisponivel',
  SEM_EMPRESTIMO = 'sem-emprestimo-contratos',
  SEM_EMPRESTIMO_DADOS_2 = 'sem-emprestimo-dados-2',
  SEM_PARCELA = 'sem-parcela',
  DESQUALIFICACAO = 'desqualificacao',
  DESQUALIFICACAO_INSS_DADOS_1 = 'desqualificacao-inss-dados-1',
  DESQUALIFICACAO_INSS_DADOS_2 = 'desqualificacao-inss-dados-2',
  DESQUALIFICACAO_SIAPE_DADOS_1 = 'desqualificacao-siape-dados-1',
  DESQUALIFICACAO_SIAPE_DADOS_2 = 'desqualificacao-siape-dados-2',
  DESQUALIFICACAO_CTPS_DADOS_1 = 'desqualificacao-ctps-dados-1',
  DESQUALIFICACAO_CTPS_DADOS_2 = 'desqualificacao-ctps-dados-2',
  INSS_BLOQUEADO = 'inss-bloqueado',
  BENEFICIO_BLOQUEADO = 'beneficio-bloqueado',
  INDISPONIVEL = 'indisponivel',
  SERVICO_INDISPONIVEL = 'servico-indisponivel',
  DESQUALIFICACAO_SIAPE_SIMULAR = 'desqualificacao-siape-simular',
  DESQUALIFICACAO_INSS_OFERTA_SEGURO = 'desqualificacao-inss-oferta-seguro',
  DESQUALIFICACAO_SIAPE_OFERTA_SEGURO = 'desqualificacao-siape-oferta-seguro',
  LISTAGEM_CONTRATOS = 'listagem-contratos',
  DESQUALIFICACAO_INSS_PROPOSTA = 'desqualificacao-inss-proposta',
  DESQUALIFICACAO_SIAPE_PROPOSTA = 'desqualificacao-siape-proposta',
  DESQUALIFICACAO_CTPS_PROPOSTA = 'desqualificacao-ctps-proposta',
  ERRO_BUSCAR_PROPOSTA = 'erro-buscar-proposta',
  ERRO_CONTRATACAO_PROPOSTA = 'erro-contratacao-proposta',
  ERRO_PROPOSTA_EM_ANDAMENTO = 'erro-proposta-em-andamento',
  ERRO_AUTH_GET_TOKEN = 'error-auth-get-token',
  ERRO_AUTH_AUTHORIZE = 'error-auth-authorize',
  ERRO_ENVIO_TRACKING = 'erro-envio-tracking',
  ERRO_STATUS_DOCUMENTOS = 'erro-status-documentos',
  ERRO_CONSULTA_MARGEM = 'erro-consulta-margem',
  ERRO_BUSCAR_ENDERECO = 'erro-buscar-endereco',
  ERRO_BUSCAR_BANCOS = 'erro-buscar-bancos',
  ERRO_BUSCAR_DADOS_PESSOAIS = 'erro-buscar-dados-pessoais',
  ERRO_SALVAR_DADOS_PESSOAIS = 'erro-salvar-dados-pessoais',
  ERRO_FINALIZAR_PROPOSTA = 'erro-finalizar-proposta',
  ERRO_CARREGAR_DADOS_BIOMETRIA = 'erro-carregar-dados-biometria',
  ERRO_BUSCAR_SEED = 'erro-buscar-seed',
  ERRO_VALIDAR_BIOMETRIA = 'erro-validar-biometria',
  ERRO_GERAR_LINK_BIOMETRIA = 'erro-gerar-link-biometria',
  INSS_INDISPONIVEL = 'inss-indisponivel',
  INSS_INDISPONIVEL_TCU = 'inss-indisponivel-tcu',

  INICIO_CAPTURA_DOCUMENTO_SERASA = 'inicio-captura-documentos-serasa',
  CAPTURA_DOCUMENTO_SERASA_SUCESSO = 'captura-documento-serasa-sucesso',

  INICIO_CAPTURA_BIOMETRIA_SERASA = 'inicio-captura-biometria-serasa',
  CAPTURA_BIOMETRIA_SERASA_SUCESSO = 'captura-biometria-serasa-sucesso',

  USE_NEW_PROVIDERS = 'use-new-providers',
  NOT_USE_NEW_PROVIDERS = 'not-use-new-providers',
  ERROR_GET_USE_NEW_PROVIDERS = 'error-get-use-new-providers',

  ERROR_GET_BIOMETRIC_ACTIVE = 'error-get-biometric-active',
  ID_CLOUD_WITH_DOCUMENTS = 'id-cloud-with-documents',
  ID_CLOUD_WITHOUT_DOCUMENTS = 'id-cloud-without-documents',
  SERASA_WITHOUT_DOCUMENTS = 'serasa-without-documents',
  SERASA_WITH_DOCUMENTS = 'serasa-with-documents',

  VERIFICACAO = 'verificacao',
  CARREGAMENTO_SIMULACAO = 'carregamento-simulacao',
  CARREGAMENTO_FORMALIZACAO = 'carregamento-formalizacao',
  CONSULTA_MARGEM_PRIMEIRA_TENTATIVA = 'consulta-margem-primeira-tentativa',
  CONSULTA_MARGEM_SEGUNDA_TENTATIVA = 'consulta-margem-segunda-tentativa',
  TERMOS = 'termos',
  TERMO_VISUALIZACAO = 'termo-visualizacao',
  SUCESSO = 'sucesso',
  MODO_ENVIO = 'modo-envio',
  DOCUMENTO_IDENTIFICACAO = 'documento-identificacao',
  FOTO_DOCUMENTO = 'foto-documento',
  FAQ = 'faq',
  TUTORIAL = 'tutorial',

  // Click steps
  CLICK_CONTRATOS_CONTINUAR = 'click-contratos-continuar',
  CLICK_OFERTA_SEGURO_SIMULAR = 'click-oferta-seguro-simular',
  CLICK_RESULTADO_SIMULACAO_SOLICITAR_CONTRATACAO = 'click-resultado-simulacao-solicitar-contratacao',
  CLICK_RESULTADO_SIMULACAO_EXIBIR_DETALHES = 'click-resultado-simulacao-exibir-detalhes',
  CLICK_RESULTADO_SIMULACAO_OCULTAR_DETALHES = 'click-resultado-simulacao-ocultar-detalhes',
  CLICK_RESULTADO_SIMULACAO_ALTERAR_PARCELAS = 'click-resultado-simulacao-alterar-parcelas',
  CLICK_REVISAO_CONFIRMAR_CONTRATACAO = 'click-revisao-confirmar-contratacao',
  CLICK_REVISAO_EXIBIR_DETALHES = 'click-revisao-exibir-detalhes',
  CLICK_REVISAO_OCULTAR_DETALHES = 'click-revisao-ocultar-detalhes',
  CLICK_REVISAO_VER_TERMOS = 'click-revisao-ver-termos',
  CLICK_REVISAO_REFAZER_BIOMETRIA = 'click-revisao-refazer-biometria',
  CLICK_TERMOS_VISUALIZAR_TERMO = 'click-termos-visualizar-termo',
  CLICK_SUCESSO_IR_HOME = 'click-sucesso-ir-home',
  CLICK_SUCESSO_ACOMPANHAR_PROPOSTA = 'click-sucesso-acompanhar-proposta',
  CLICK_SUCESSO_ABRIR_CONTA = 'click-sucesso-abrir-conta',
  CLICK_STATUS_DOCUMENTOS_CONTINUAR = 'click-status-documentos-continuar',
  CLICK_STATUS_DOCUMENTOS_DOCUMENTO_IDENTIFICACAO = 'click-status-documentos-documento-identificacao',
  CLICK_STATUS_DOCUMENTOS_CONTRACHEQUE = 'click-status-documentos-contracheque',
  CLICK_TIPO_DOCUMENTO_CNH = 'click-tipo-documento-cnh',
  CLICK_TIPO_DOCUMENTO_RG = 'click-tipo-documento-rg',
  CLICK_TIPO_DOCUMENTO_CIN = 'click-tipo-documento-cin',
  CLICK_TIPO_DOCUMENTO_DNI = 'click-tipo-documento-dni',
  CLICK_TIPO_DOCUMENTO_RNE = 'click-tipo-documento-rne',
  CLICK_TIPO_DOCUMENTO_RNM = 'click-tipo-documento-rnm',
  CLICK_TIPO_DOCUMENTO_CARTEIRA_FUNCIONAL = 'click-tipo-documento-carteira-funcional',
  CLICK_MODO_ENVIO_TIRAR_FOTO = 'click-modo-envio-tirar-foto',
  CLICK_MODO_ENVIO_ANEXAR_DOCUMENTO = 'click-modo-envio-anexar-documento',
  CLICK_FOTO_DOCUMENTO_USAR_FOTO = 'click-foto-documento-usar-foto',
  CLICK_FOTO_CONTRACHEQUE_USAR_FOTO = 'click-foto-contracheque-usar-foto',
  CLICK_ENDERECO_CONFIRMAR = 'click-endereco-confirmar',
  CLICK_ENDERECO_CANCELAR = 'click-endereco-cancelar',
  CLICK_DADOS_BANCARIOS_CONFIRMAR = 'click-dados-bancarios-confirmar',
  CLICK_DADOS_BANCARIOS_CANCELAR = 'click-dados-bancarios-cancelar',
  CLICK_INFORMACOES_PESSOAIS_CONFIRMAR = 'click-informacoes-pessoais-confirmar',
  CLICK_INFORMACOES_PESSOAIS_ALTERAR_ENDERECO = 'click-informacoes-pessoais-alterar-endereco',
  CLICK_INFORMACOES_PESSOAIS_ALTERAR_BANCARIOS = 'click-informacoes-pessoais-alterar-bancarios',
  CLICK_CONVENIO_VISUALIZAR_TERMO = 'click-convenio-visualizar-termo',
  CLICK_CONVENIO_CONTINUAR = 'click-convenio-continuar',
}

export type ConvenioKind = 'INSS' | 'SIAPE' | 'CTPS'

export const getConvenioKind = (convenioCodigo: number): ConvenioKind => {
  if (convenioCodigo === ConveniosCodes.SIAPE_SERVIDOR_FEDERAL) return 'SIAPE'
  if (convenioCodigo === ConveniosCodes.CTPS) return 'CTPS'
  return 'INSS'
}

export const ConveniosMultiContratosBloqueado = [
  'Pref Belo Horizonte',
  'Estado da Bahia',
  'Marinha do Brasil',
  'Pref Salvador',
  'Força Aérea Brasileira',
  'Pref de Contagem',
  'Hospital Odilon Behrens',
  'TRE - MG',
  'Metro',
  'STJ - Superior Tribunal de Justiça',
  'TCE- Tribunal de Contas do Estado de Minas Gerais',
  'SJMG - Seção Judiciária de Minas Gerais - MG',
  'STF - Supremo Tribunal Federal',
  'Estado de Mato Grosso',
]

export const EmprestimoProtegidoBeneficios = [
  {
    icone: <ISafe height={24} width={24} color={Colors.GRAY500} />,
    titulo: 'Tenha tranquilidade',
    descricao: 'Em caso de morte ou invalidez, seu empréstimo é quitado',
  },
  {
    icone: <PrepaymentOfReceivables height={24} width={24} color={Colors.GRAY500} />,
    titulo: 'Crédito rápido',
    descricao:
      'Seu crédito é liberado em até 3 dias, caso esteja tudo certo com a sua documentação',
  },
]

export const EmprestimoBeneficios = [
  {
    icone: <PrepaymentOfReceivables height={24} width={24} color={Colors.GRAY500} />,
    titulo: 'Crédito rápido',
    descricao:
      'Seu crédito é liberado em até 3 dias, caso esteja tudo certo com a sua documentação',
  },
]

export enum CCBEnum {
  CCBEXERCITO = 'exercito',
  CCB = 'ccb',
}

export enum ConsignanteApi {
  SEF = 'SEPLAG',
  CBMMG = 'Bombeiros',
  IPSEMG = 'IPSEMG',
  PMMG = 'PMMG',
  IPSM = 'IPSM',
  DPMG = 'Defensoria Publica MG',
}

export enum ConsignantePdf {
  SEF = 'SEF',
  CBMMG = 'CBMMG',
  IPSEMG = 'IPSEMG',
  PMMG = 'PMMG',
  IPSM = 'IPSM',
  DPMG = 'DPMG',
}

export enum Consignado {
  SERVIDOR = 'servidor',
  BOLSISTA = 'bolsista',
  PENSIONISTA = 'pensionista',
  CONTRATADO = 'contratado',
}

export enum TipoDocumento {
  RG = 'rg',
  CNH = 'cnh',
  CIN = 'cin',
  DNI = 'dni',
  RNE = 'rne',
  RNM = 'rnm',
  CARTEIRA_FUNCIONAL = 'carteira_funcional',
  CONTRACHEQUE = 'contracheque',
}

export type TipoDocumentoIdentificacao =
  | 'cnh'
  | 'rg'
  | 'cin'
  | 'dni'
  | 'rne'
  | 'rnm'
  | 'carteira_funcional'

export const DOCUMENTOS_IDENTIFICACAO: Array<{ name: string; value: TipoDocumentoIdentificacao }> =
  [
    { name: 'Carteira de motorista (CNH)', value: TipoDocumento.CNH },
    { name: 'RG', value: TipoDocumento.RG },
    { name: 'Carteira de Identidade Nacional (CIN)', value: TipoDocumento.CIN },
    { name: 'Documento Nacional de Identidade (DNI)', value: TipoDocumento.DNI },
    { name: 'Registro Nacional de Estrangeiro (RNE)', value: TipoDocumento.RNE },
    { name: 'Registro Nacional Migratório (RNM)', value: TipoDocumento.RNM },
    { name: 'Carteira funcional', value: TipoDocumento.CARTEIRA_FUNCIONAL },
  ]

export enum TipoMiniatura {
  RG_FRENTE = 'rg-frente',
  RG_VERSO = 'rg-verso',
  CNH_FRENTE = 'cnh-frente',
  CNH_VERSO = 'cnh-verso',
  RNE_FRENTE = 'rne-frente',
  RNE_VERSO = 'rne-verso',
}

export enum PendenciaEnumV3 {
  PENDENCIA_REVERSIVEL_LEAD_NOVO = 'PENDENCIA_REVERSIVEL_LEAD_NOVO',
  PENDENCIA_IRREVERSIVEL = 'PENDENCIA_IRREVERSIVEL',
  PENDENCIA_TEIMOSINHA = 'PENDENCIA_TEIMOSINHA',
  PENDENCIA_VALIDACAO = 'PENDENCIA_VALIDACAO',
}

/**
 * Códigos de resposta da API para consulta de margem
 */
export enum MarginErrorCodes {
  // sucesso
  SUCCESS = 'R0000',
  // erro geral
  ERROR = 'R0001',
  // erro inss indisponivel
  ERROR_INSS_INDISPONIVEL = 'R0008',
  // não elegível
  NOT_ELIGIBLE = 'R0002',
  // desqualificado
  DISQUALIFIED = 'R0003',
  // beneficio inss bloqueado
  INSS_BLOQUEADO = 'R0004',
  // primeira tentativa de autorização SIAPE
  FIRST_RETRY_AUTH_SIAPE = 'R0005',
  // segunda tentativa de autorização SIAPE
  SECOND_RETRY_AUTH_SIAPE = 'R0006',
  // indisponível por processamento de virada de competência
  PROCESSAMENTO_VIRADA_COMPETENCIA = 'MA0007',
  // desqualificado com cross cc - listagem de contratos
  DISQUALIFIED_CROSS_CS001 = 'CS001',
  // desqualificado com cross cc - simulation result
  DISQUALIFIED_CROSS_CS002 = 'CS002',
  // desqualificado com cross cc - simulation result
  DISQUALIFIED_CROSS_CS005 = 'CS005',
  // desqualificado com cross nc - simulation result
  DISQUALIFIED_CROSS_CS003 = 'CS003',
  // desqualificado com cross nc - simulation result
  DISQUALIFIED_CROSS_CS006 = 'CS006',
  // erro ao buscar proposta - getproposal
  DISQUALIFIED_CROSS_CS007 = 'CS007',
  // erro ao buscar proposta - getproposal
  DISQUALIFIED_CROSS_CS008 = 'CS008',
  PROPOSTA_EM_ANDAMENTO = 'R0010',
}

export const ConveniosUrl = {
  [ConveniosCodes.INSS]: 'inss',
  [ConveniosCodes.SIAPE_SERVIDOR_FEDERAL]: 'siape',
  [ConveniosCodes.CTPS]: 'ctps',
}
